"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendAttributeValueOrPath = void 0;
const isObject_js_1 = require("../../../utils/validation/isObject.js");
const isString_js_1 = require("../../../utils/validation/isString.js");
const isAttributePath = (valueOrPath) => (0, isObject_js_1.isObject)(valueOrPath) && 'attr' in valueOrPath && (0, isString_js_1.isString)(valueOrPath.attr);
const appendAttributeValueOrPath = (conditionParser, attribute, expressionAttributeValueOrPath, options = {}) => {
    if (isAttributePath(expressionAttributeValueOrPath)) {
        conditionParser.appendAttributePath(expressionAttributeValueOrPath.attr, options);
    }
    else {
        conditionParser.appendAttributeValue(attribute, expressionAttributeValueOrPath, options);
    }
};
exports.appendAttributeValueOrPath = appendAttributeValueOrPath;
